import React from 'react';

const SelectContext = React.createContext(null);

export default SelectContext;


// WEBPACK FOOTER //
// ./src/lib/SelectContext/index.js